import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import * as ValidationUtils from "../../utils/ValidationUtils";
import validator from "validator";
import useAppModalService from "../../hooks/useAppModalService";
import LoginPopUp from "../PopUps/LoginPopUp/LoginPopUp";
import {getSetKeyValueFromQS} from "../../utils/AppUtils";
import {FormattedMessage} from "react-intl";
import './SignUpForm.style.scss';
import TermsOfUsePopUp from "../PopUps/TermsOfUsePopUp/TermsOfUsePopUp";
import {registerAsync} from "../../stores/account/account.thunks";
import {useDispatch, useSelector} from "react-redux";
import {selectLocale, selectUserIsAuthenticated, selectUserLanguage} from "../../stores/account/account.selectors";
import {useLocation, useNavigate} from "react-router-dom";
import RegistrationFailedPopUp from "../PopUps/RegistrationFailedPopUp/RegistrationFailedPopUp";
import RegistrationSuccessPopUp from "../PopUps/RegistrationSuccessPopUp/RegistrationSuccessPopUp";
import {resetRegistrationError} from "../../stores/account/account.slice";
import GlobalConst from "../../constants/GlobalConst";
import {getUtmData} from "../../services/UtmTracker";
import PrivyLoginButton from "../../components/Privy/PrivyLoginButton";
import {usePrivy} from "@privy-io/react-auth";


const SignUpForm = () => {
    const [isRegistering, setIsRegistering] = useState(false);
    const locale = useSelector(selectUserLanguage);
    const [model, setModel] = useState({
        UserName: '',
        FirstName: '',
        Email: '',
        Password: '',
        ReferrerName: '',
        ReferrerSite: '',
        ReferrerId: '',
        ReferrerCode: '',
        Term1: true,
        PhoneNumber: '',
        RequestId: '',
        RegisterHostPrefix: 'pickx',
        RegisterHost: 'pickx' + GlobalConst.SITE_URLS.DOMAIN,
        Culture: locale
    });
    const [errors, setErrors] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const isUserAuthenticated = useSelector(selectUserIsAuthenticated);
    const {openModal} = useAppModalService();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const {ready: isPrivyReady} = usePrivy();


    useEffect(() => {

        const params = new URLSearchParams(location.search);
        const promoCode = params.get("promoCode");

        setModel((prevModel) => ({...prevModel,
            Term1: true,
            ReferrerCode: promoCode ? promoCode : ''}));

        detectReferer();
    }, []);

    useEffect(() => {
        if (isUserAuthenticated) {
             navigate("/lobby");
        }
    }, [isUserAuthenticated]);

    const detectReferer = () => {
        const siteReferrer = getSetKeyValueFromQS();
        if (siteReferrer) {
            setModel((prevModel) => ({
                ...prevModel,
                ReferrerSite: siteReferrer
            }));
        }
        const referrerId = getSetKeyValueFromQS();
        if (referrerId) {
            setModel((prevModel) => ({
                ...prevModel,
                ReferrerId: referrerId
            }));
        }
    };

    const handleTermOfUseClick = async () => {
        await openModal('termOfUsePopUp', 'info', {
            title: 'Term of Use',
            modalComponent: TermsOfUsePopUp,
        });
    }

    const handleRegistrationFailed = async () => {
        await openModal('registrationFailed', 'info', {
            title: 'Register Failed',
            modalComponent: RegistrationFailedPopUp,
            onOk: () => {
                setModel((prevModel) => ({
                    ...prevModel,
                    UserName: '',
                    Email: '',
                    Password: '',
                }));

                dispatch(resetRegistrationError());
                window.location.reload();
                document.getElementById("UserName").focus();
            },
        }
        );
    }

    const handleRegistrationSuccess = async () => {

        window.twq?.('event', 'tw-q8p5z-qaq7d', {});
        window.fbq?.('track', 'CompleteRegistration');

        await openModal('registrationSuccess', 'info', {
            title: 'Register Success',
            modalComponent: RegistrationSuccessPopUp,
            onOk: () => {
                navigate("/lobby");
            },
        });
    }

    const promptCookieYesConsentAgain = () => {
        const cookieNames = ["cookieyes-consent"];
        const path = "/";
        const domain = ".www.tradefan.com";
        cookieNames.forEach((name) => {
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${domain};`;
        });
        window.location.reload();
    };

    const onSubmit = async (e) => {
        e.preventDefault();

        if (!model.UserName || isRegistering) {
            setErrors(<FormattedMessage id={"signUp.errors.requireUserName"}/>);
            return;
        }

        if (!validator.isAlphanumeric(model.UserName)) {
            setErrors(<FormattedMessage id={"signUp.errors.invalidUserName"}/>);
            return;
        }

        if (!model.Password || isRegistering) {
            setErrors(<FormattedMessage id={"signUp.errors.invalidPassword"}/>);
            return;
        }

        if (!model.Email || isRegistering || !ValidationUtils.isEmailValid(model.Email)) {
            setErrors(<FormattedMessage id={"signUp.errors.invalidEmail"}/>);
            return;
        }

        if (model.Password.length < 6) {
            setErrors(<FormattedMessage id={"signUp.errors.invalidPasswordLength"}/>);
            return;
        }

        let registerModel = { ...model };
        registerModel.ConfirmPassword = registerModel.Password;
        registerModel.Term1 = registerModel.Term1 ? "on" : "off";
        const utmData = getUtmData();
        if (utmData) {
            registerModel = { ...registerModel,
                              ...utmData };
        }

        let res;
        res = await dispatch(registerAsync(registerModel));

        if (res.payload) {
            await handleRegistrationSuccess();
        } else {
            await handleRegistrationFailed()
        }

        setIsRegistering(true);
        setErrors(null);
    };

    const openLoginPopUp = async () => {
        await openModal('Login', 'loginPopUp', {
            title: 'Login',
            modalComponent: LoginPopUp,
        });
    };


    return (
        <div className="SignUpForm">
            <p className="text-center createAccountText">
                <b> <FormattedMessage id={"signUp.createAccountFree"}/> </b>
            </p>
            <p className="text-center text-muted playForFreeText"><FormattedMessage
                id={"signUp.playForFreeNoCCRequired"}/></p>
            <div>
                <div>
                    <form className="form-horizontal" onSubmit={onSubmit}>
                        {errors && (<div className="validation-summary-errors">
                            <span>{errors}</span>
                        </div>)}

                        <div>
                            <div>
                                <div className="form-group">
                                    <label htmlFor={"UserName"}
                                           className="userNameLabel">
                                        <FormattedMessage id={"signUp.chooseUserName"}/>
                                    </label>
                                    <input
                                        className="form-control"
                                        id="UserName"
                                        name="UserName"
                                        type="text"
                                        value={model.UserName}
                                        onChange={(e) => {
                                            const userName = e.target.value;
                                            setModel((prevModel) => ({...prevModel, UserName: userName}));
                                        }}
                                    />
                                </div>
                            </div>
                            <div>
                                <div className="form-group">
                                    <label htmlFor={"Email"}
                                           className="emailLabel"><FormattedMessage id={"signUp.email"}/></label>
                                    <input
                                        className="form-control"
                                        data-val="true"
                                        id="Email"
                                        name="Email"
                                        type="text"
                                        value={model.Email}
                                        onChange={(e) => {
                                            setModel((prevModel) => ({...prevModel, Email: e.target.value}));
                                        }}
                                    />
                                </div>
                            </div>
                            <div>
                                <div className="form-group">
                                    <label htmlFor={"Password"}
                                           className="passwordLabel"><FormattedMessage
                                        id={"signUp.setPassword"}/></label>
                                    <input
                                        className="form-control"
                                        id="Password"
                                        name="Password"
                                        type={showPassword ? "text" : "password"}
                                        value={model.Password}
                                        onChange={(e) => {
                                            setModel((prevModel) => ({...prevModel, Password: e.target.value}));
                                        }}
                                    /><i className="fa-solid fa-eye" onClick={ () => {
                                    setShowPassword(!showPassword)
                                }} />
                                </div>
                            </div>

                            <div>
                                <div className="form-group">
                                    <label htmlFor={"ReferrerCode"}
                                           className="referrerCodeLabel"><FormattedMessage id={"signUp.referrerCode"}/></label>
                                    <input
                                        className="form-control"
                                        id="ReferrerCode"
                                        name="referrer"
                                        type="text"
                                        value={model.ReferrerCode}
                                        onChange={(e) => {
                                            setModel((prevModel) => ({...prevModel, ReferrerCode: e.target.value}));
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div>
                            <div>
                                <label className="signupTerm" htmlFor="term1">
                                    <FormattedMessage id={"signUp.registerIAgree"}/>{" "}
                                    <a
                                        className="term1"
                                        onClick={() => {
                                            handleTermOfUseClick();
                                        }}
                                    >
                                        <FormattedMessage id={"signUp.iAgreeLink"}/>
                                    </a>{" "}
                                    <FormattedMessage id={"signUp.iAgree2"}/>
                                </label>
                            </div>
                            <div className="btnCol">
                                <div className="form-group" style={{marginTop: 20}}>
                                    <div className="text-center">
                                        <button
                                            id="submitBtn"
                                            type="submit"
                                            className="btn btn-primary btn-lg "
                                        >
                                            {isRegistering && <i className="fa fa-fw fa-spinner fa-spin"/>}
                                            <FormattedMessage id={"signUp.register"}/>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="haveAccount">
                                <label >
                                    <FormattedMessage id={"signUp.alreadyHaveAccount"}/>
                                    <a
                                        className="term1"
                                        onClick={() => {
                                            openLoginPopUp();
                                        }}
                                    >
                                        {" "}
                                        <FormattedMessage id={"signUp.signIn"}/>
                                    </a>{" "}
                                </label>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div style={{clear: "both"}}/>

            {/*isPrivyReady && GlobalConst.FEATURES.PRIVY_LOGIN && <div className={"privyLoginContainer"}>
                <div className={"or"}><span><FormattedMessage id={'popUp.login.or'}/></span></div>
                <div className={"or-text"}>
                    <FormattedMessage id={'popUp.login.orText'}/>
                </div>
                <PrivyLoginButton primary />
            </div>*/}

        </div>
    );
};

SignUpForm.propTypes = {
    cbFunc: PropTypes.func,
};

export default SignUpForm;